export default defineNuxtRouteMiddleware(async (to, from) => {
  const navbarStore = useNavbarStore()

  // setup the navbarstore
  if (navbarStore.isAlreadyInitialized === false) {
    navbarStore.setup()
  }
})
